import React, { useState } from 'react';
import apiClient from '../api/client';

const styles = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#f8fafc',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: '2rem',
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    border: '1px solid #e2e8f0',
    padding: '2.5rem',
    width: '100%',
    maxWidth: '760px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
    marginTop: '1rem',
    marginBottom: '2rem',
  },
  formGroup: {
    marginBottom: '1.1rem',
  },
  label: {
    display: 'block',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: '#1e293b',
    marginBottom: '0.4rem',
  },
  input: {
    width: '100%',
    padding: '0.75rem 0.875rem',
    borderRadius: '8px',
    border: '1px solid #e2e8f0',
    fontSize: '0.9rem',
    color: '#1e293b',
    outline: 'none',
    boxSizing: 'border-box',
  },
  select: {
    width: '100%',
    padding: '0.75rem 0.875rem',
    borderRadius: '8px',
    border: '1px solid #e2e8f0',
    fontSize: '0.9rem',
    color: '#1e293b',
    backgroundColor: '#ffffff',
    outline: 'none',
    boxSizing: 'border-box',
  },
  textarea: {
    width: '100%',
    padding: '0.75rem 0.875rem',
    borderRadius: '8px',
    border: '1px solid #e2e8f0',
    fontSize: '0.9rem',
    color: '#1e293b',
    outline: 'none',
    minHeight: '140px',
    resize: 'vertical',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
  },
  btn: {
    width: '100%',
    padding: '0.75rem',
    backgroundColor: '#01696F',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '0.95rem',
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: '0.5rem',
    minHeight: '44px',
  },
  error: {
    backgroundColor: '#fef2f2',
    border: '1px solid #fecaca',
    color: '#ef4444',
    borderRadius: '8px',
    padding: '0.75rem',
    fontSize: '0.875rem',
    marginBottom: '1rem',
  },
  success: {
    backgroundColor: '#f0fdfa',
    border: '1px solid #99f6e4',
    color: '#01696F',
    borderRadius: '8px',
    padding: '0.75rem',
    fontSize: '0.875rem',
    marginBottom: '1rem',
  },
};

const handleFocus = (e) => { e.target.style.borderColor = '#01696F'; e.target.style.boxShadow = '0 0 0 3px rgba(1, 105, 111, 0.15)'; };
const handleBlur = (e) => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none'; };

export default function ContactPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('General Inquiry');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      await apiClient.post('/api/contact', { name, email, subject, message });
      setSuccess(true);
      setName('');
      setEmail('');
      setSubject('General Inquiry');
      setMessage('');
    } catch (err) {
      const msg = err.response?.data?.error || 'Something went wrong. Please try again.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <a href="/" style={{ color: '#01696F', fontSize: '0.85rem', textDecoration: 'none' }}>&larr; Back to home</a>

        <h1 style={{ color: '#1e293b', fontSize: '1.5rem', fontWeight: '700', marginTop: '1.5rem', marginBottom: '0.5rem' }}>Contact Us</h1>
        <p style={{ color: '#64748b', fontSize: '0.9rem', marginBottom: '2rem' }}>
          Have a question, found a bug, or want to request a feature? We'd love to hear from you.
        </p>

        {error && <div role="alert" style={styles.error}>{error}</div>}
        {success && <div role="status" style={styles.success}>Message sent! We'll get back to you within 48 hours.</div>}

        <form onSubmit={handleSubmit}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Name</label>
            <input
              type="text"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              onFocus={handleFocus}
              onBlur={handleBlur}
              style={styles.input}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onFocus={handleFocus}
              onBlur={handleBlur}
              style={styles.input}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Subject</label>
            <select
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              onFocus={handleFocus}
              onBlur={handleBlur}
              style={styles.select}
            >
              <option value="General Inquiry">General Inquiry</option>
              <option value="Bug Report">Bug Report</option>
              <option value="Feature Request">Feature Request</option>
              <option value="Account Issue">Account Issue</option>
            </select>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Message</label>
            <textarea
              required
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onFocus={handleFocus}
              onBlur={handleBlur}
              style={styles.textarea}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              ...styles.btn,
              ...(loading ? { opacity: 0.6, cursor: 'not-allowed' } : {}),
            }}
          >
            {loading ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
    </div>
  );
}
